import { Routes, Route, Navigate, Outlet } from 'react-router-dom';

// Layout components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Home from './pages/home/Home';
import Team from './pages/team/Team';
import Contact from './pages/contact/Contact';
import PrivacyPolicy from './pages/policy/PrivacyPolicy';
import Chat from './pages/chat/Chat';
import AccessPage from './pages/chat/AccessPage';
import InvalidLink from './pages/chat/InvalidLink';
import WelcomePage from './pages/welcome/WelcomePage';
import ResetPassword from './pages/forgot/ResetPassword';

// Admin & Auth Pages
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';

// Route Guards
import PrivateRoute from './components/PrivateRoute'; // For Clinical Scribe users
import ProtectedRoute from './components/ProtectedRoute'; // For Admin users

// This wraps everything in the AuthProvider "bubble"
import { AuthProvider } from './context/AuthContext';
import { MRNProvider } from './context/MRNContext';

// This component wraps only the pages that NEED the Navbar/Footer
const PublicLayout = () => (
  <div className="app-wrapper">
    <Navbar />
    <main className="app-main">
      <Outlet /> {/* This is where the specific page renders */}
    </main>
    <Footer />
  </div>
);

function AppContent() {
  return (
    <Routes>
      {/* 1. LAYOUT GROUP: Pages WITH Navbar/Footer */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/team" element={<Team />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/invalid-link" element={<InvalidLink />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Route>

      {/* 2. ADMIN & AUTH ROUTES: No Navbar/Footer */}
      <Route path="admin/login" element={<Login />} />
      <Route
        path="admin/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* 3. ISOLATED PAGES: No Navbar/Footer */}

      {/* Access link (usually a splash/loading state) */}
      <Route path="/a/:accessCode" element={<AccessPage />} />
      {/* Protected Welcome - Full Screen */}
      <Route
        path="/welcome"
        element={
          <PrivateRoute>
            <WelcomePage />
          </PrivateRoute>
        }
      />
      {/* Protected Chat - Full Screen */}
      <Route
        path="/chat"
        element={
          <PrivateRoute>
            <Chat />
          </PrivateRoute>
        }
      />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/invalid-link" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <MRNProvider>
        <AppContent />
      </MRNProvider>  
    </AuthProvider >
  );
}

export default App;